
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator"
import { InsightFormattingOptions, createDefaultInsightFormattingOptions } from "@/types/insights/formattingOptions"
import { InsightDetails } from "@/types/insights"
import InsightCalculationTableFormatting from "./InsightCalculationTableFormatting.vue"

enum FormattingPanel {
	CalculationTable = "calculationTable"
}

@Component({
	components: {
		"calculation-table-formatting": InsightCalculationTableFormatting
	}
})
export default class InsightFormatting extends Vue {
	/* --- Props --- */

	@Prop({ type: Object, default: () => {} })
	private readonly value!: InsightFormattingOptions

	@Prop({ type: Object, required: true })
	private readonly insight!: InsightDetails

	/* --- Data --- */
	private FormattingPanel = FormattingPanel

	private expandedPanel: string | null = null

	/* --- Lifecycle hooks --- */

	private mounted () {
		if (!this.value) {
			this.setValue(createDefaultInsightFormattingOptions())
		}
	}

	/* --- Vue-related functions --- */

	private get internalValue (): InsightFormattingOptions {
		return this.value
	}

	private set internalValue (value: InsightFormattingOptions) {
		if (value) {
			this.setValue(value)
		} else {
			this.setValue(createDefaultInsightFormattingOptions())
		}
	}

	@Watch("insight")
	private onInsightChanged () {
		if (!this.value) {
			this.setValue(createDefaultInsightFormattingOptions())
		}
	}

	@Emit("input")
	private setValue (value: InsightFormattingOptions) {
		return value
	}
}

